import webdev from "../images/webdev.jpg"
import appdev from "../images/appdev.jpg"
import digimrkt from "../images/digimrkt.jpg"

const webData = [
    {
        imgsrc: webdev,
        title: "Web Development",
        explore: "/service/web-dev",
    },
    {
        imgsrc: appdev,
        title: "App Development",
        explore: "/service/app-dev",

    },
    {
        imgsrc: digimrkt,
        title: "Digital Marketing",
        explore: "/service/digi-mrkt",
    },
]

export default webData